<script setup lang="ts">
import { MtdButton, MtdContainer, MtdPopover, MtdTypography } from '@paygine/mtd-uikit'

import { EditIcon, SbpIcon, TrashIcon } from '@/shared/icons'
import { ref } from 'vue'
import MoreIcon from '@/shared/icons/MoreIcon.vue'

const props = defineProps<{
    active?: boolean
    bank: {
        bankName: string
        id: number
        logoUrl: string
        subtitle: string
    }
    borderless?: boolean
    canDelete?: boolean
    canEdit: boolean
    clickable?: boolean
}>()

const emit = defineEmits<{
    'payMethod:change': []
    'payMethod:delete': []
    'payMethod:update': []
}>()

const isActionVisible = ref(false)

function handleClick() {
    emit('payMethod:change')
}

function handleDelete() {
    emit('payMethod:delete')
    isActionVisible.value = false
}
</script>

<template>
    <MtdContainer
        :class="[
            'pay-method',
            { _borderless: props.borderless, _active: props.active, _clickable: props.clickable },
        ]"
        @click="handleClick"
    >
        <div class="pay-method__icon">
            <img
                :src="props.bank.logoUrl"
                :alt="props.bank.bankName"
            />
        </div>

        <div class="pay-method__name">
            <MtdTypography
                tag="span"
                variant="textbody-2-medium"
                >{{ props.bank.bankName }}</MtdTypography
            >
            <div class="pay-method__sort">
                <SbpIcon class="pay-method__sort-icon" />
                <MtdTypography
                    tag="p"
                    class="pay-method__sbp"
                    variant="textbody-3"
                    >{{ props.bank.subtitle || 'СБП' }}</MtdTypography
                >
            </div>
        </div>

        <MtdPopover
            v-if="clickable"
            v-model="isActionVisible"
            trigger="click"
            position="bottom-end"
            :offset="12"
            :alignment-offset="-8"
            class="pay-method__action-trigger"
            container-class="pay-method__actions"
            content-class="pay-method__actions-content"
        >
            <template #control="slotProps">
                <MtdButton
                    v-bind="slotProps"
                    size="xs"
                    type="button"
                    variant="main-white"
                    @click.stop
                    class="pay-method__action-button"
                >
                    <MoreIcon />
                </MtdButton>
            </template>

            <template #content>
                <MtdButton
                    v-if="props.canEdit"
                    size="sm"
                    variant="main-secondary"
                    class="pay-method__edit"
                    type="button"
                >
                    <EditIcon @click="emit('payMethod:update')" />
                </MtdButton>

                <MtdButton
                    v-show="props.canDelete"
                    size="sm"
                    class="pay-method__delete"
                    variant="danger-flat"
                    type="button"
                    @click.stop="handleDelete"
                >
                    <template #icon>
                        <TrashIcon />
                    </template>
                    Удалить
                </MtdButton>
            </template>
        </MtdPopover>
    </MtdContainer>
</template>

<style src="./VPayMethod.scss" lang="scss"></style>
